import { useEffect } from "react";
import { useUser } from "@clerk/clerk-react";
import * as Sentry from "@sentry/react";

/**
 * SentryUser syncs the signed-in Clerk user into Sentry's scope so events and
 * replays are attributed to a user. It clears the user on sign-out.
 *
 * Rendered inside ClerkProvider; safe to mount even when Sentry is a no-op.
 */
export function SentryUser() {
  const { isLoaded, isSignedIn, user } = useUser();

  useEffect(() => {
    if (!isLoaded) {
      return;
    }
    if (isSignedIn && user) {
      Sentry.setUser({
        id: user.id,
        email: user.primaryEmailAddress?.emailAddress,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [isLoaded, isSignedIn, user]);

  return null;
}
